import { __assign, __rest } from "tslib";
import React from 'react';
import { Card } from '@marvelapp/ui';
import Loading from './Loading';
export default function CardCopying(_a) {
    var isSelected = _a.isSelected, props = __rest(_a, ["isSelected"]);
    return (React.createElement(Card, { isSelected: isSelected },
        React.createElement(Loading, __assign({}, props))));
}
